import React from "react";
import './phoneImageStyle.css';

function hexToRgbA(hex, alpha = 1) {
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+`,${alpha})`;
    }
    throw new Error('Bad Hex');
  }

const PhoneImage = (props) => {
    const { sun } = props;
	return (
        <div className='phone_img-wrapper'>
            <div className='phone-interior_img'>
                <img src={require('../../../content/assets/iPhone_background.png')} className='phone_img_background' />
                <div className='phone-foreground_img'>
                    <div className='dynamic-sun' style={{ backgroundColor: sun }}></div>
                    <img src={require('../../../content/assets/homepage_foreground.png')} className='phone_img_foreground' />
                </div>
            </div>
        </div>
	)
}

export default PhoneImage;